import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, Button, Modal } from 'react-bootstrap'
import "./clinics.css"
import { useAlert } from 'react-alert';
import Plans from "../SalesManagement/Plans";
import AddCredits from "./AddCredits";
import { Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import { useApiContext } from "../../contexts/ApiContext";
function Credits(props) {
    const { setIsApiSuccess } = useApiContext();
    const alert = useAlert()
    let id = props.id
    const [sms, setSms] = useState({})
    const [email, setEmail] = useState({})
    const [Wapp, setWapp] = useState({})
    const [addCredits, setAddCredits] = useState(false)
    const [type, setType] = useState("")
    const [wallet, setWallet] = useState(0)
    const [orders, setOrders] = useState([])
    const [status, setStatus] = useState("not_paid")
    const [refresh, setRefresh] = useState(false)
    useEffect(() => {setOrders([]);setRefresh(!refresh)},[props.id])
    useEffect(() => {
        const tokenString = sessionStorage.getItem('usertoken');
        let str = tokenString.replace(/["]+/g, '')
        axios.get(`${APIURL}/api/v1/service-provider/clinic-top-up/?payment_status=${status}&hospital_id=${props.id}&${TZ}`, {
            headers: {
                "Authorization": 'Token ' + str
            }
        })
            .then(res => {

                if (res.data.status === "success") {
                    setOrders(res.data.top_ups)
                }
            })
            .catch(err => {

            })
    }, [status,refresh]);

    useEffect(() => {

        const tokenString = sessionStorage.getItem('usertoken');

        let str = tokenString.replace(/["]+/g, '')

        axios.get(`${APIURL}/api/v1/service-provider/clinic-credit-detail/?payment_status=paid&hospital_id=${props.id}&${TZ}`, {
            headers: {

                "Authorization": 'Token ' + str
            }
        })
            .then(res => {

                if (res.data.status === "success") {
                    const filteredData1 = res.data.credit_detail.filter(item => {
                        return item.channel_type === 'whatsapp'
                    })
                    const filteredData2 = res.data.credit_detail.filter(item => {
                        return item.channel_type === 'sms'
                    })
                    const filteredData3 = res.data.credit_detail.filter(item => {
                        return item.channel_type === 'email'
                    })
                    setSms(filteredData2[0].channel_type?filteredData2[0]:{})
                    setEmail(filteredData3[0].channel_type?filteredData3[0]:{})
                    setWapp(filteredData1[0].channel_type?filteredData1[0]:{})
                    

                }


            })
            .catch(err => {

            })


    }, []);
    const AddCreditsPopUp = (props) => {
        return (
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header style={{ textTransform: "capitalize" }} closeButton><b>{type}</b></Modal.Header>
                <Modal.Body style={{ textAlign: "center" }}>
                    <AddCredits type={type} wallet={wallet} id={id} onSuccess={() => {setRefresh(!refresh);setAddCredits(false)}}/>

                </Modal.Body>

            </Modal>
        )
    }
    const handleDelete = (id1) => {
        
        const tokenString = sessionStorage.getItem("usertoken");
        let str = tokenString.replace(/["]+/g, "");
        axios
            .delete(`${APIURL}/api/v1/service-provider/clinic-top-up/?topup_id=${id1}&hospital_id=${props.id}&${TZ}`, {
                headers: {
                    Authorization: "Token " + str,
                    "Content-Type": "application/json",
                },
            })

            .then((res) => {

                if (res.data.status === "success") {
                    alert.success(res.data.message)
                    setIsApiSuccess(true);
                    setRefresh(!refresh)
                } else {
                    alert.error(res.data.message);
                }
            })
            .catch((err) => {
                alert.error("error in submission")
            });

    };



    const displayCredits = (item) => {


        return (
            <div className="col-12" style={{ padding: "1%" }}>
                <div style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#cbdadb", padding: "1%" }}>
                    <div className="d-flex justify-content-between">
                        <b>Total credit</b>

                        <>&nbsp;<b> {item.total_credit}</b></>

                    </div>

                    <div style={{ backgroundColor: "white", padding: "1%" }}>
                        <div className="row" style={{ margin: "auto" }}>
                            <small className="col-7">Consumed credit</small>

                            <b className="col-4">
                                {item.consumed_credit}
                            </b>
                            <small className="col-7">Remaining credits</small>

                            <b className="col-4" style={{ color: "green" }} >
                                {item.remaing_credits}
                            </b>
                            <small className="col-7">Used messages</small>

                            <b className="col-4">
                                {item.used_messages}/{item.total_messages}
                            </b>
                            <small className="col-7">Over used messages</small>

                            <b className="col-4" style={{color:item.over_used_messages>0&&"orange"}}>
                                {item.over_used_messages}
                            </b>

                        </div>
                    </div>
                </div>
            </div>
        );
    };


    return (<>

        <div className="row" style={{ marginBottom: "1%", }}>
            <h5 class="" style={{}} ><b>Active credits</b></h5>
           {sms.channel_type&& <div className="col-4" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#FDF5EE", padding: "1%" }}>
                <h6 className="row">
                    <div className="col-3"><b >Sms</b></div>
                    <div className="col-8 row">



                    </div>
                    <div className="col-1">
                        <button onClick={(e) => { setWallet(sms.remaing_credits); setType("sms"); setAddCredits(true) }
                        } style={{ cursor: "pointer", height: "22px" }} className="clinic_button"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10h-4V6a2 2 0 0 0-4 0l.071 4H6a2 2 0 0 0 0 4l4.071-.071L10 18a2 2 0 0 0 4 0v-4.071L18 14a2 2 0 0 0 0-4" /></svg></button>
                    </div>

                </h6>
                <div className="container-fluid">
                    <div className="row">
                        {displayCredits(sms)}

                    </div>
                </div>

            </div>}
            {Wapp.channel_type&&<div className=" col-4" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#F9FEF8", padding: "1%", }}>
                <h6 className="row">
                    <div className="col-3"><b >Whatsapp</b></div>
                    <div className="col-8 row">
                    </div>
                    <div className="col-1">
                        <button onClick={(e) => { setWallet(Wapp.remaing_credits); setType("whatsapp"); setAddCredits(true) }
                        } style={{ cursor: "pointer", height: "22px" }} className="clinic_button"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10h-4V6a2 2 0 0 0-4 0l.071 4H6a2 2 0 0 0 0 4l4.071-.071L10 18a2 2 0 0 0 4 0v-4.071L18 14a2 2 0 0 0 0-4" /></svg></button>
                    </div>

                </h6>
                <div className="container-fluid">
                    <div className="row">
                        {displayCredits(Wapp)}
                    </div>
                </div>
            </div>}
            {email.channel_type&& <div className="col-4" style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#FAF1F3", padding: "1%", }}>
                <h6 className="row">
                    <div className="col-3"><b >Email</b></div>
                    <div className="col-8 row">
                    </div>
                    <div className="col-1">
                        <button onClick={(e) => { setWallet(email.remaing_credits); setType("email"); setAddCredits(true) }
                        } style={{ cursor: "pointer", height: "22px" }} className="clinic_button"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10h-4V6a2 2 0 0 0-4 0l.071 4H6a2 2 0 0 0 0 4l4.071-.071L10 18a2 2 0 0 0 4 0v-4.071L18 14a2 2 0 0 0 0-4" /></svg></button>
                    </div>

                </h6>
                <div className="container-fluid">
                    <div className="row">

                        {displayCredits(email)}


                    </div>
                </div>
            </div>}



        </div>
        <div className="row" >
            <h5 class="col-5" style={{paddingTop: "0.8%",}} ><b>Orders</b></h5>
            <div className="col-7" style={{ display: "flex" }}>
                <b style={{ paddingTop: "0.8%", fontSize: "18px", color: status === "paid" ? "rgba(85, 71, 159, 0.72)" : "gray" }}>Paid</b>&nbsp;&nbsp;&nbsp;&nbsp;
                {status === "paid" ? <svg onClick={() => { setStatus("not_paid") }} xmlns="http://www.w3.org/2000/svg" fill="rgba(85, 71, 159, 0.72)" width="38" height="38" viewBox="0 0 256 256" id="Flat">
                    <path d="M176,52H80a76,76,0,0,0,0,152h96a76,76,0,0,0,0-152Zm0,128H80A52,52,0,0,1,80,76h96a52,52,0,0,1,0,104ZM80,92a36,36,0,1,0,36,36A36.04061,36.04061,0,0,0,80,92Zm0,48a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,80,140Z" /><path xmlns="http://www.w3.org/2000/svg" d="M176,52H80a76,76,0,0,0,0,152h96a76,76,0,0,0,0-152Zm0,128H80A52,52,0,0,1,80,76h96a52,52,0,0,1,0,104ZM80,92a36,36,0,1,0,36,36A36.04061,36.04061,0,0,0,80,92Zm0,48a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,80,140Z" />
                </svg> : <svg onClick={() => { setStatus("paid") }} xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="rgba(85, 71, 159, 0.72)"><path d="M17 6H7a6 6 0 1 0 0 12h10a6 6 0 0 0 0-12Z" fill="#000000" fill-opacity=".16" stroke="#000000" stroke-width="1.5" stroke-miterlimit="10" />
                    <path d="M17 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill="#ffffff" stroke="#000000" stroke-width="1.5" stroke-miterlimit="10" />
                    {/* <path xmlns="http://www.w3.org/2000/svg" d="M17 6H7a6 6 0 1 0 0 12h10a6 6 0 0 0 0-12Z" fill="none"  stroke="rgba(85, 71, 159, 0.72)" stroke-width="1.5" stroke-miterlimit="10"/> */}
                    <path xmlns="http://www.w3.org/2000/svg" d="M17 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill="rgba(85, 71, 159, 0.72)" stroke="#000000" stroke-width="1.5" stroke-miterlimit="10" />
                </svg>}
                &nbsp;&nbsp;&nbsp;&nbsp;<b style={{ paddingTop: "0.8%", fontSize: "18px", color: status === "not_paid" ? "rgba(85, 71, 159, 0.72)" : "gray" }}>Not paid</b>
            </div>
            <div className="col-12" style={{marginBottom:"2%"}}>
                <div className="row " style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left", padding: "1%", borderRadius: "5px 5px 0px 0px" }}>
                    {/* <div  className="col-1">ID</div> */}
                    <div className="col-3">Channel</div>
                    <div className="col-3"><b >Purchased credit</b></div>
                    <div className="col-2"><b >Price</b></div>
                    <div className="col-2"><b >Messages</b></div>

                    <div className="col-2"><b > </b></div>

                </div>
                {orders.length > 0 && orders.map((item) => {
                    return (
                        <div className="row " style={{ textAlign: "left", borderLeft: "0.4px solid gray", borderBottom: "0.4px solid gray", borderRight: "0.4px solid gray" }}>

                            <div style={{ padding: "1%", textTransform: "capitalize", backgroundColor: "aliceblue", cursor: "pointer" }} className="col-3">{item.channel_type}</div>
                            <div style={{ padding: "1%"}} className="col-3">{item.purchased_credit}</div>
                            <div style={{ padding: "1%"}} className="col-2">Rs {item.price}/-</div>
                            <div style={{ padding: "1%"}} className="col-2">{item.total_message}</div>

                            <div style={{ padding: "1%"}}className="col-2">
                               {item.payment_status==="not_paid"&&item.license_bill_details.payment_link===null&& <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">Send payment link</Tooltip>}>
                   <svg    onClick={(e) => {
                   const tokenString = sessionStorage.getItem("usertoken");

                   let v2 = tokenString.replace(
                       /["]+/g,
                       ""
                   ); /* REGEX To remove double quotes from tokenstring */
                  
                   const dataToSend = {
                       
                       license_bill_id:item.license_bill_details.license_bill_id
                       
                   }
           
                   axios
                       .post(`${APIURL}/api/v1/payment/razorpay-link/`, dataToSend, {
                           headers: { Authorization: "Token " + v2 },
                       })
                       .then((res) => {
                           if (res.data.status === "success") {
                            
                              alert.success(res.data.message)
                             setRefresh(!refresh)
                               
                           } else {
                               alert.error(res.data.message)
                              
                           }
                       })
                       .catch((err) => {
                           
                           
                       });
                   
                  }} xmlns="http://www.w3.org/2000/svg" style={{marginTop:""}} width="28" height="28" viewBox="0 0 24 24"><path fill="#2b69a3" d="M3 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h10.5a6.5 6.5 0 0 1-.5-2.5a6.5 6.5 0 0 1 6.5-6.5a6.5 6.5 0 0 1 1.5.18V6a2 2 0 0 0-2-2zm0 2l8 5l8-5v2l-8 5l-8-5zm16 6l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4zm-3.33 3.29c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12z"/></svg>
                              
                             </OverlayTrigger>}&nbsp;&nbsp;&nbsp;
                             {item.payment_status==="not_paid"&& <svg  onClick={(e) => {handleDelete(item.id)}} style={{marginTop:"",float:"right"}} xmlns="http://www.w3.org/2000/svg"  width="22" height="22" viewBox="0 0 448 512"><path fill="red" d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>}
                             </div>
                        </div>

                    )
                })}

            </div>




        </div>
        {
            addCredits ?
                <AddCreditsPopUp
                    show={addCredits}
                    onHide={() => { setRefresh(!refresh);setAddCredits(false) }} /> : null
        }
    </>
    );
}
export default Credits;
